import { END_POINTS } from '../constants/urls';
import emptySplitApi from '../utils/rtk';

export const assetApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    createAsset: builder.mutation<any, {
      asset_type: string;
      source_url: string;
      mime_type: string;
      width: number;
      height: number;
      regions: string;
    }>({
      query: (body) => ({
        url: END_POINTS.assets,
        method: 'POST',
        body,
      }),
    }),
    getAsset: builder.query<any, string>({
      query: (assetId) => ({
        url: `${END_POINTS.assets}${assetId}/`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useCreateAssetMutation,
  useLazyGetAssetQuery,
} = assetApi;
